import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InnerCircle } from './components/InnerCircle';
import { RadioButtonContainer } from './components/RadioButtonContainer';

function RadioButton({ onClick, value, selected, disabled }) {
  const onThisClick = () => {
    if (onClick) onClick(value);
  };

  return (
    <RadioButtonContainer
      onClick={onThisClick}
      selected={selected}
      disabled={disabled}
    >
      <InnerCircle />
    </RadioButtonContainer>
  );
}

RadioButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default styled(RadioButton)``;
